import { getFontFullPath } from '@/Pages/Clip/SideBar/FontSelector/constants';
import { CaptionLineConfig, CaptionStyles } from '@/domains/asset';
import { TransitionInEffect } from '@/App/remotion/libs/transitions/types';

const snazzy: Partial<CaptionStyles> = {
  theme_preset: 'snazzy',
  pageStyle: {
    color: '#ffffff',
    background: '#795dd8',
    borderRadius: '16px',
    paddingLeft: '16px',
    paddingRight: '16px'
  },
  wordStyle: undefined,
  letterStyle: undefined,
  font_location: getFontFullPath('Poppins-Bold.ttf'),
  caps: false,
  line_config: CaptionLineConfig.OneLine,
  font_size: 72,
  transitions: {
    pageIn: TransitionInEffect.Fade
  }
};

export default snazzy;
